export const placesService = () => {
  if (window && window.google && window.google.maps && window.google.maps.places) {
    return new window.google.maps.places.PlacesService(
      document.createElement('div')
    )
  } else {
    return null
  }
}
